export const user_type = {
	EMPLOYER: 'Employer',
	JOB_SEEKER: 'Job-Seeker',
};

export const account_subscription_type = {
	FREE: 'free',
	PROFESSIONAL: 'professional',
};

export function errorMessage(error) {
	return error?.response?.data?.error;
}

export function isEmployer(currentUser) {
	return currentUser?.profile?.user_type === user_type.EMPLOYER;
}

export function isJobSeeker(currentUser) {
	return currentUser?.profile?.user_type === user_type.JOB_SEEKER;
}

export function hasActiveFreeSubscription(currentUser) {
	return currentUser?.has_active_free_subscription;
}

export function userExists(currentUser) {
	return currentUser?.profile;
}

export function hasCreatedProfile(currentUser) {
	return currentUser?.profile?.first_name;
}

export function hasProfessionalAccount(currentUser) {
	return currentUser?.account_subscription_type === account_subscription_type.PROFESSIONAL;
}

export function accountInCancellationState(currentUser) {
	return currentUser?.account_stripe_subscription_in_cancellation_state;
}

export function hasProfessionalAccountAndIsInCancellationState(currentUser) {
	return hasProfessionalAccount(currentUser) && accountInCancellationState(currentUser);
}

export function hasProfessionalAccountAndIsEmployer(currentUser) {
	return hasProfessionalAccount(currentUser) && isEmployer(currentUser);
}

export function hasFreeAccount(currentUser) {
	return currentUser?.account_subscription_type === account_subscription_type.FREE;
}

export function isStaffMember(currentUser) {
	return currentUser?.email.endsWith('@permworks.com') || currentUser?.email.endsWith('@permhunt.com');
}

const allowedAdminEmails = ['elias@permhunt.com', 'tim@permhunt.com', 'eliaskhouryy@hotmail.com', 'sue@permworks.com', 'tim@permworks.com', 'elias@permworks.com', 'michael@permhunt.com', 'drew@permhunt.com', 'tony@permhunt.com'];

export const isAdmin = (currentUser) => allowedAdminEmails.includes(currentUser?.email);

export function isNotEmailAuth(currentUser) {
	return currentUser?.auth_provider !== 'email';
}

export function hasTwoFactorEnabled(currentUser) {
	return currentUser?.two_factor_enabled;
}

export function hasTwoFactorEnabledAndIsEmailAuth(currentUser) {
	return currentUser?.two_factor_enabled && currentUser?.auth_provider === 'email';
}

export function doesNotHaveTwoFactorEnabledAndIsEmailAuth(currentUser) {
	return !currentUser?.two_factor_enabled && currentUser?.auth_provider === 'email';
}

export function hasBeenPromptedForJobPreferences(currentUser) {
	return currentUser?.has_been_prompted_for_job_preferences;
}
